// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__11266","animating":"styles_animating__3bQcb","open":"styles_open__uZuhb"};